<template>
  <div class="product_card_layout " :class="{ 'disabled_card': item.hidden }" v-if="!islist && !deleted">
    <div class="product-card">
      <div class="tile_label tile_sale" v-if="item.discount">
        <span class="text">-{{ item.discount }}%</span>
      </div>
      <div class="tile_label tile_new" v-if="hot">
        <span class="text">{{ $static('cp.n', 'новий') }}</span>
      </div>
      <div class="product-card_img bg editor_trigger" @click="$emit('open', $event)"
        :style="{ backgroundImage: $filters.backgroundImage(item.preview) }">


      </div>
      <div class="product-card_content">
        <div class="product-card_main">
          <a href="javascript:void(0);" class="product-card__title editor_trigger" @click="$emit('open', $event)">{{
            $dynamic(item, item.title, 'title') }}</a>
          <!--product card info-->
          <div class="product-card_info_box" @click="$emit('open', $event)">
            <div class="price-box">
              <div class="price-element">
                {{ $filters.money(item.price) }}
                <small class="currency">{{ $store.getters.symbol }}</small>
              </div>
              <div class="price-element price-old" v-if="item.price_old">
                {{ $filters.money(item.price_old) }}
                <small class="currency">{{ $store.getters.symbol }}</small>
              </div>
            </div>
            <div class="available in_stock" v-if="item.stock">{{ $static('cp.st', 'в наявності') }}</div>
            <div class="available out_stock" v-else>{{ $static('cp.nst', 'нет в наличии') }}</div>
          </div>
          <!--end product card info-->
          <div class="options-box">
            <div class="option-line">
              <div class="option-name">{{ $static('cp.stt', 'Наличие товара') }}</div>
              <div class="toggle-holder">
                <div class="toggler r" @click.stop="">
                  <input type="checkbox" class="toggle-check" v-model.boolean="item.stock" value="1">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
            <div class="option-line">
              <div class="option-name">{{ $static('cp.h', 'Скрыть товар') }}</div>
              <div class="toggle-holder">
                <div class="toggler r" @click.stop="">
                  <input type="checkbox" class="toggle-check" v-model.boolean="item.hidden" value="1">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="actions-box">
            <Popper arrow :content="$static('cp.edit', 'Редагувати')" hover placement="top" style="white-space: nowrap">
              <button class="btn-icon  btn-rounded editor_trigger" @click="$emit('open', $event)">
                <span class="icon icon-edit"></span>
              </button>
            </Popper>

            <Popper arrow :content="$static('iconsbtn.copy', 'Дублювати')" hover placement="top"
              style="white-space: nowrap">
              <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger" @click.prevent.stop="makeCopy">
                <span class="icon icon-3copy3"></span>
              </button>
            </Popper>

            <Popper arrow :content="$static('iconsbtn.copy-link', 'Копіювати посилання')" hover placement="top"
              style="white-space: nowrap">
              <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger" @click="copyLink">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1441_7)">
                    <path
                      d="M6.37082 20.1667C5.16843 20.1616 4.01618 19.6843 3.16249 18.8375C2.73565 18.4193 2.39656 17.9201 2.16506 17.3692C1.93357 16.8183 1.81433 16.2268 1.81433 15.6292C1.81433 15.0316 1.93357 14.4401 2.16506 13.8892C2.39656 13.3382 2.73565 12.8391 3.16249 12.4209L6.46249 9.12086C6.8807 8.69403 7.37987 8.35493 7.93078 8.12344C8.48169 7.89194 9.07325 7.77271 9.67082 7.77271C10.2684 7.77271 10.8599 7.89194 11.4109 8.12344C11.9618 8.35493 12.4609 8.69403 12.8792 9.12086C13.0115 9.29738 13.0758 9.51574 13.0602 9.73584C13.0445 9.95594 12.95 10.163 12.794 10.319C12.638 10.4751 12.4309 10.5696 12.2108 10.5852C11.9907 10.6009 11.7723 10.5366 11.5958 10.4042C11.0818 9.90032 10.3906 9.61809 9.67082 9.61809C8.951 9.61809 8.25987 9.90032 7.74582 10.4042L4.44582 13.7042C3.93528 14.2147 3.64846 14.9072 3.64846 15.6292C3.64846 16.3512 3.93528 17.0437 4.44582 17.5542C4.95636 18.0647 5.6488 18.3516 6.37082 18.3516C7.09283 18.3516 7.78528 18.0647 8.29582 17.5542L10.3583 15.4C10.5348 15.2676 10.7532 15.2034 10.9733 15.219C11.1934 15.2346 11.4005 15.3292 11.5565 15.4852C11.7125 15.6412 11.807 15.8483 11.8227 16.0684C11.8383 16.2885 11.774 16.5068 11.6417 16.6834L9.57915 18.8375C8.72546 19.6843 7.57321 20.1616 6.37082 20.1667Z"
                      fill="#212121" />
                    <path
                      d="M12.3292 14.2083C11.1268 14.2033 9.97453 13.7259 9.12083 12.8791C8.98844 12.7026 8.92417 12.4843 8.93981 12.2642C8.95545 12.0441 9.04996 11.837 9.20599 11.681C9.36201 11.5249 9.56909 11.4304 9.78919 11.4148C10.0093 11.3991 10.2276 11.4634 10.4042 11.5958C10.9182 12.0997 11.6093 12.3819 12.3292 12.3819C13.049 12.3819 13.7401 12.0997 14.2542 11.5958L17.5542 8.29581C18.0647 7.78527 18.3515 7.09283 18.3515 6.37081C18.3515 5.6488 18.0647 4.95636 17.5542 4.44581C17.0436 3.93527 16.3512 3.64845 15.6292 3.64845C14.9072 3.64845 14.2147 3.93527 13.7042 4.44581L11.6417 6.59998C11.4651 6.73237 11.2468 6.79665 11.0267 6.78101C10.8066 6.76537 10.5995 6.67086 10.4435 6.51483C10.2875 6.3588 10.1929 6.15173 10.1773 5.93163C10.1617 5.71153 10.2259 5.49317 10.3583 5.31665L12.4208 3.16248C13.2747 2.32573 14.4242 1.85974 15.6197 1.86578C16.8151 1.87182 17.9599 2.34939 18.8053 3.19473C19.6506 4.04006 20.1282 5.18484 20.1342 6.38031C20.1402 7.57577 19.6743 8.72532 18.8375 9.57915L15.5375 12.8791C14.6838 13.7259 13.5316 14.2033 12.3292 14.2083Z"
                      fill="#212121" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1441_7">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </Popper>

            <Popper arrow :content="$static('iconsbtn.copy-ux-link', 'Копіювати посилання')"
              v-if="settings?.env?.TGLINK" hover placement="top" style="white-space: nowrap">
              <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger" @click="copyUXLink">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1441_7)">
                    <path
                      d="M6.37082 20.1667C5.16843 20.1616 4.01618 19.6843 3.16249 18.8375C2.73565 18.4193 2.39656 17.9201 2.16506 17.3692C1.93357 16.8183 1.81433 16.2268 1.81433 15.6292C1.81433 15.0316 1.93357 14.4401 2.16506 13.8892C2.39656 13.3382 2.73565 12.8391 3.16249 12.4209L6.46249 9.12086C6.8807 8.69403 7.37987 8.35493 7.93078 8.12344C8.48169 7.89194 9.07325 7.77271 9.67082 7.77271C10.2684 7.77271 10.8599 7.89194 11.4109 8.12344C11.9618 8.35493 12.4609 8.69403 12.8792 9.12086C13.0115 9.29738 13.0758 9.51574 13.0602 9.73584C13.0445 9.95594 12.95 10.163 12.794 10.319C12.638 10.4751 12.4309 10.5696 12.2108 10.5852C11.9907 10.6009 11.7723 10.5366 11.5958 10.4042C11.0818 9.90032 10.3906 9.61809 9.67082 9.61809C8.951 9.61809 8.25987 9.90032 7.74582 10.4042L4.44582 13.7042C3.93528 14.2147 3.64846 14.9072 3.64846 15.6292C3.64846 16.3512 3.93528 17.0437 4.44582 17.5542C4.95636 18.0647 5.6488 18.3516 6.37082 18.3516C7.09283 18.3516 7.78528 18.0647 8.29582 17.5542L10.3583 15.4C10.5348 15.2676 10.7532 15.2034 10.9733 15.219C11.1934 15.2346 11.4005 15.3292 11.5565 15.4852C11.7125 15.6412 11.807 15.8483 11.8227 16.0684C11.8383 16.2885 11.774 16.5068 11.6417 16.6834L9.57915 18.8375C8.72546 19.6843 7.57321 20.1616 6.37082 20.1667Z"
                      fill="#212121" />
                    <path
                      d="M12.3292 14.2083C11.1268 14.2033 9.97453 13.7259 9.12083 12.8791C8.98844 12.7026 8.92417 12.4843 8.93981 12.2642C8.95545 12.0441 9.04996 11.837 9.20599 11.681C9.36201 11.5249 9.56909 11.4304 9.78919 11.4148C10.0093 11.3991 10.2276 11.4634 10.4042 11.5958C10.9182 12.0997 11.6093 12.3819 12.3292 12.3819C13.049 12.3819 13.7401 12.0997 14.2542 11.5958L17.5542 8.29581C18.0647 7.78527 18.3515 7.09283 18.3515 6.37081C18.3515 5.6488 18.0647 4.95636 17.5542 4.44581C17.0436 3.93527 16.3512 3.64845 15.6292 3.64845C14.9072 3.64845 14.2147 3.93527 13.7042 4.44581L11.6417 6.59998C11.4651 6.73237 11.2468 6.79665 11.0267 6.78101C10.8066 6.76537 10.5995 6.67086 10.4435 6.51483C10.2875 6.3588 10.1929 6.15173 10.1773 5.93163C10.1617 5.71153 10.2259 5.49317 10.3583 5.31665L12.4208 3.16248C13.2747 2.32573 14.4242 1.85974 15.6197 1.86578C16.8151 1.87182 17.9599 2.34939 18.8053 3.19473C19.6506 4.04006 20.1282 5.18484 20.1342 6.38031C20.1402 7.57577 19.6743 8.72532 18.8375 9.57915L15.5375 12.8791C14.6838 13.7259 13.5316 14.2033 12.3292 14.2083Z"
                      fill="#212121" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1441_7">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </Popper>


            <Popper arrow :content="$static('cp.del', 'Видалити')" hover placement="top" style="white-space: nowrap">
              <a href="#" class="btn-icon btn-remove btn-icon-transparent btn-rounded"
                @click.prevent.stop="$emit('remove', $event)">
                <span class="icon icon-trash-filled"></span>
              </a>
            </Popper>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!--product card preview-->
  <div class="product_card_layout card_list" :class="{ 'disabled_card': item.hidden }" v-else-if="!deleted"
    style="cursor: pointer" @click="$emit('open', $event)">
    <div class="product-card">
      <div class="product-card_content">
        <div class="product-card_main">
          <div class="product-card_img bg editor_trigger"
            :style="{ backgroundImage: $filters.backgroundImage(item.preview) }">
            <div class="tile_label tile_sale" v-if="item.discount">
              <span class="text">-{{ item.discount }}%</span>
            </div>
            <div class="tile_label tile_new" v-if="hot">
              <span class="text">{{ $static('cp.n', 'новий') }}</span>
            </div>
          </div>
          <a href="javascript:void(0);" class="product-card__title editor_trigger">{{
            $dynamic(item, item.title, 'title') }}</a>
        </div>
        <div class="price-box">
          <div class="price-element">
            {{ $filters.money(item.price) }}
            <small class="currency">{{ $store.getters.symbol }}</small>
          </div>
        </div>

        <div class="price-box">
          <div class="price-element price-old">
            <template v-if="item.price_old">
              {{ $filters.money(item.price_old) }}
              <small class="currency">{{ $store.getters.symbol }}</small>
            </template>
            <template v-else>-</template>
          </div>
        </div>

        <div class="category">{{ categoryName }}</div>
        <div class="available in_stock" v-if="item.stock"><span>{{ $static('cp.st', 'в наявності') }}</span></div>
        <div class="available out_stock" v-else><span>{{ $static('cp.nst', 'нет в наличии') }}</span></div>

        <div class="toggle-holder toggle-check-available" @click.stop="">
          <div class="toggle-name">{{ $static('catalog.t6', 'Доступність продукту') }}</div>
          <div class="toggler r">
            <input type="checkbox" class="toggle-check" v-model.boolean="item.stock" value="1">
            <div class="knobs"></div>
            <div class="layer"></div>
          </div>
        </div>
        <div class="toggle-holder toggle-hidden-product" @click.stop="">
          <div class="toggle-name">{{ $static('catalog.t7', 'Приховати товар') }}</div>
          <div class="toggler r">
            <input type="checkbox" class="toggle-check" v-model.boolean="item.hidden" value="1">
            <div class="knobs"></div>
            <div class="layer"></div>
          </div>
        </div>
        <div class="actions-box">
          <div class="actions-name">{{ $static('catalog.t8', 'Виконання дії') }}</div>
          <div class="dropdown btn-drop" ref="openElement" @click.prevent.stop="">
            <button class="dropdown-toggle btn-icon btn-rounded btn-icon-transparent" @click.prevent.stop="makeOpen"
              type="button" id="dropdownMenuButtons" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="icon icon-more-alt"></span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButtons">
              <li @click="$emit('open', $event)">
                <div class="text">{{ $static('iconsbtn.edit', 'Редагувати') }}</div>
                <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger">
                  <span class="icon icon-edit"></span>
                </button>
              </li>
              <li @click="copyLink">
                <div class="text">{{ $static('iconsbtn.copy-link', 'Копіювати посилання') }}</div>
                <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1441_7)">
                      <path
                        d="M6.37082 20.1667C5.16843 20.1616 4.01618 19.6843 3.16249 18.8375C2.73565 18.4193 2.39656 17.9201 2.16506 17.3692C1.93357 16.8183 1.81433 16.2268 1.81433 15.6292C1.81433 15.0316 1.93357 14.4401 2.16506 13.8892C2.39656 13.3382 2.73565 12.8391 3.16249 12.4209L6.46249 9.12086C6.8807 8.69403 7.37987 8.35493 7.93078 8.12344C8.48169 7.89194 9.07325 7.77271 9.67082 7.77271C10.2684 7.77271 10.8599 7.89194 11.4109 8.12344C11.9618 8.35493 12.4609 8.69403 12.8792 9.12086C13.0115 9.29738 13.0758 9.51574 13.0602 9.73584C13.0445 9.95594 12.95 10.163 12.794 10.319C12.638 10.4751 12.4309 10.5696 12.2108 10.5852C11.9907 10.6009 11.7723 10.5366 11.5958 10.4042C11.0818 9.90032 10.3906 9.61809 9.67082 9.61809C8.951 9.61809 8.25987 9.90032 7.74582 10.4042L4.44582 13.7042C3.93528 14.2147 3.64846 14.9072 3.64846 15.6292C3.64846 16.3512 3.93528 17.0437 4.44582 17.5542C4.95636 18.0647 5.6488 18.3516 6.37082 18.3516C7.09283 18.3516 7.78528 18.0647 8.29582 17.5542L10.3583 15.4C10.5348 15.2676 10.7532 15.2034 10.9733 15.219C11.1934 15.2346 11.4005 15.3292 11.5565 15.4852C11.7125 15.6412 11.807 15.8483 11.8227 16.0684C11.8383 16.2885 11.774 16.5068 11.6417 16.6834L9.57915 18.8375C8.72546 19.6843 7.57321 20.1616 6.37082 20.1667Z"
                        fill="#212121" />
                      <path
                        d="M12.3292 14.2083C11.1268 14.2033 9.97453 13.7259 9.12083 12.8791C8.98844 12.7026 8.92417 12.4843 8.93981 12.2642C8.95545 12.0441 9.04996 11.837 9.20599 11.681C9.36201 11.5249 9.56909 11.4304 9.78919 11.4148C10.0093 11.3991 10.2276 11.4634 10.4042 11.5958C10.9182 12.0997 11.6093 12.3819 12.3292 12.3819C13.049 12.3819 13.7401 12.0997 14.2542 11.5958L17.5542 8.29581C18.0647 7.78527 18.3515 7.09283 18.3515 6.37081C18.3515 5.6488 18.0647 4.95636 17.5542 4.44581C17.0436 3.93527 16.3512 3.64845 15.6292 3.64845C14.9072 3.64845 14.2147 3.93527 13.7042 4.44581L11.6417 6.59998C11.4651 6.73237 11.2468 6.79665 11.0267 6.78101C10.8066 6.76537 10.5995 6.67086 10.4435 6.51483C10.2875 6.3588 10.1929 6.15173 10.1773 5.93163C10.1617 5.71153 10.2259 5.49317 10.3583 5.31665L12.4208 3.16248C13.2747 2.32573 14.4242 1.85974 15.6197 1.86578C16.8151 1.87182 17.9599 2.34939 18.8053 3.19473C19.6506 4.04006 20.1282 5.18484 20.1342 6.38031C20.1402 7.57577 19.6743 8.72532 18.8375 9.57915L15.5375 12.8791C14.6838 13.7259 13.5316 14.2033 12.3292 14.2083Z"
                        fill="#212121" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1441_7">
                        <rect width="22" height="22" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </li>
              <li v-if="settings?.env?.TGLINK" @click="copyUXLink">
                <div class="text">{{ $static('iconsbtn.copy-ux-link', 'Копіювати UX лінк') }}</div>
                <button class=" btn-icon btn-rounded btn-icon-transparent editor_trigger">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1441_7)">
                      <path
                        d="M6.37082 20.1667C5.16843 20.1616 4.01618 19.6843 3.16249 18.8375C2.73565 18.4193 2.39656 17.9201 2.16506 17.3692C1.93357 16.8183 1.81433 16.2268 1.81433 15.6292C1.81433 15.0316 1.93357 14.4401 2.16506 13.8892C2.39656 13.3382 2.73565 12.8391 3.16249 12.4209L6.46249 9.12086C6.8807 8.69403 7.37987 8.35493 7.93078 8.12344C8.48169 7.89194 9.07325 7.77271 9.67082 7.77271C10.2684 7.77271 10.8599 7.89194 11.4109 8.12344C11.9618 8.35493 12.4609 8.69403 12.8792 9.12086C13.0115 9.29738 13.0758 9.51574 13.0602 9.73584C13.0445 9.95594 12.95 10.163 12.794 10.319C12.638 10.4751 12.4309 10.5696 12.2108 10.5852C11.9907 10.6009 11.7723 10.5366 11.5958 10.4042C11.0818 9.90032 10.3906 9.61809 9.67082 9.61809C8.951 9.61809 8.25987 9.90032 7.74582 10.4042L4.44582 13.7042C3.93528 14.2147 3.64846 14.9072 3.64846 15.6292C3.64846 16.3512 3.93528 17.0437 4.44582 17.5542C4.95636 18.0647 5.6488 18.3516 6.37082 18.3516C7.09283 18.3516 7.78528 18.0647 8.29582 17.5542L10.3583 15.4C10.5348 15.2676 10.7532 15.2034 10.9733 15.219C11.1934 15.2346 11.4005 15.3292 11.5565 15.4852C11.7125 15.6412 11.807 15.8483 11.8227 16.0684C11.8383 16.2885 11.774 16.5068 11.6417 16.6834L9.57915 18.8375C8.72546 19.6843 7.57321 20.1616 6.37082 20.1667Z"
                        fill="#212121" />
                      <path
                        d="M12.3292 14.2083C11.1268 14.2033 9.97453 13.7259 9.12083 12.8791C8.98844 12.7026 8.92417 12.4843 8.93981 12.2642C8.95545 12.0441 9.04996 11.837 9.20599 11.681C9.36201 11.5249 9.56909 11.4304 9.78919 11.4148C10.0093 11.3991 10.2276 11.4634 10.4042 11.5958C10.9182 12.0997 11.6093 12.3819 12.3292 12.3819C13.049 12.3819 13.7401 12.0997 14.2542 11.5958L17.5542 8.29581C18.0647 7.78527 18.3515 7.09283 18.3515 6.37081C18.3515 5.6488 18.0647 4.95636 17.5542 4.44581C17.0436 3.93527 16.3512 3.64845 15.6292 3.64845C14.9072 3.64845 14.2147 3.93527 13.7042 4.44581L11.6417 6.59998C11.4651 6.73237 11.2468 6.79665 11.0267 6.78101C10.8066 6.76537 10.5995 6.67086 10.4435 6.51483C10.2875 6.3588 10.1929 6.15173 10.1773 5.93163C10.1617 5.71153 10.2259 5.49317 10.3583 5.31665L12.4208 3.16248C13.2747 2.32573 14.4242 1.85974 15.6197 1.86578C16.8151 1.87182 17.9599 2.34939 18.8053 3.19473C19.6506 4.04006 20.1282 5.18484 20.1342 6.38031C20.1402 7.57577 19.6743 8.72532 18.8375 9.57915L15.5375 12.8791C14.6838 13.7259 13.5316 14.2033 12.3292 14.2083Z"
                        fill="#212121" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1441_7">
                        <rect width="22" height="22" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </li>

              <li @click.prevent.stop="makeCopy">
                <div class="text">{{ $static('iconsbtn.copy', 'Дублювати') }}</div>
                <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger">
                  <span class="icon icon-3copy3"></span>
                </button>
              </li>

              <li @click.prevent.stop="$emit('remove', $event)">
                <div class="text">{{ $static('iconsbtn.delete', 'Видалити') }}</div>
                <a href="#" class="btn-icon btn-rounded btn-icon-transparent btn-remove">
                  <span class="icon icon-trash"></span>
                </a>
              </li>
            </ul>
          </div>
          <div class="buttons d-flex">


          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end product card preview-->
</template>
<script>
import api from '@/api'

export default {
  name: 'CatalogProductPreview',
  props: ['item', 'islist'],
  emits: ['open', 'remove', 'onCopy'],
  data() {
    return {
      load: false
    }
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.link);
      this.$notify({
        title: 'Copy',
        text: this.$static('notify.copyed', 'Збережено у буфер'),
        duration: 3000
      });
    },
    copyUXLink() {
      navigator.clipboard.writeText(this.tglink);
      this.$notify({
        title: 'Copy',
        text: this.$static('notify.copyed', 'Збережено у буфер'),
        duration: 3000
      });
    },
    makeCopy() {
      let copy = Object.assign({}, this.item, { hidden: true });
      delete copy['id'];
      delete copy['updated_at'];
      delete copy['created_at'];

      // console.log('make copy', copy)
      api.post('/api/item', copy).then(response => response.data).then((data) => {
        if (data.error) {
          this.$notify({
            title: 'Copy',
            type: 'error',
            text: data.error,
            duration: 10000
          });
          return
        }
        this.$emit('onCopy')
      })
    },
    makeOpen() {
      let element = this.$refs.openElement;
      let status = element.classList.contains('open');
      document.querySelectorAll('.dropdown.btn-drop').forEach(x => x.classList.remove('open'));
      if (status) {
        element.classList.remove('open');
      } else {
        element.classList.add('open')
      }
    }
  },
  computed: {
    settings() {
      return this.$store.getters.settings
    },
    options() {
      return this.$store.getters.options
    },
    link() {
      let host = location.host;
      host = host.replace('admin.', '');
      return `${location.protocol}//${host}/catalog/${this.category.info.url}/${this.item.id}`
    },
    tglink() {
      let hex = parseInt(this.item.id, 10).toString(16)
      return this.settings.env.TGLINK + `?startapp=t${hex}`
    },
    categories() {
      return this.options.find(x => x.option_id === 'category')
    },
    category() {
      return this.categories ? this.categories.list.find(x => x.id == this.item.category) : this.item.category
    },
    categoryName() {
      return this.category && this.category.name ? this.$dynamic(this.category, this.category.name, 'name') : this.category
    },
    isHidden() {
      return this.item.hidden
    },
    isStockOut() {
      return this.item.stock
    },
    deleted() {
      return this.item.deleted
    },
    hot: {
      get() {
        try {
          return this.item.advanced.hot
        } catch (e) {
          return false
        }
      },
      set(value) {
        this.item.advanced = Object.assign({}, this.item.advanced, { hot: value })
      }
    }
  },
  watch: {
    // item(val){
    //   console.log('item newval', val)
    // }
    isHidden(val, oldVal) {
      if (this.load) {
        return
      }
      this.load = true;
      // console.log('isHidden', val, oldVal);
      api.put('/api/item', {
        id: this.item.id,
        hidden: val
      }).then(response => response.data).then(data => {
        this.load = false;
        this.item.hidden = data.hidden;
        this.item.updated_at = data.updated_at;
      })
    },
    isStockOut(val, oldVal) {
      if (this.load) {
        return
      }
      this.load = true;
      // console.log('isStockOut', val, oldVal);
      api.put('/api/item', {
        id: this.item.id,
        stock: val
      }).then(response => response.data).then(data => {
        this.load = false;
        this.item.stock = data.stock;
        this.item.updated_at = data.updated_at;
      })
    }

  }
}
</script>